import type { ChangelogEntry } from "../types";

/**
 * VIB-2836. Faktureringsplanen kan endres underveis i prosjektet, og PL kan
 * lage en mellomfaktura utenfor planen. Terminfakturaer vises som
 * «Mellomfaktura» i stedet for «Mersalg».
 */
export const MELLOMFAKTURA_2026_10: ChangelogEntry = {
  id: "2026-10-07-mellomfaktura",
  date: "2026-10-07",
  title: "Mellomfaktura og endring av faktureringsplanen",
  summary:
    "Du kan endre faktureringsplanen under Detaljer og lage en mellomfaktura når kunden ber om det.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "user",
      items: [
        {
          title: "Endre faktureringsplanen under Detaljer",
          kind: "nytt",
          body: "Faktureringsplanen kan nå endres på prosjektets Detaljer, med samme editor som i tilbudet. Ledd som allerede er fakturert er låst, og leddene som gjenstår må gå opp i det som er igjen av kontrakten. Endringen står i prosjektloggen med gammel og ny plan.",
        },
        {
          title: "Mellomfaktura utenfor planen",
          kind: "nytt",
          body: "Under Faktura kan du lage en mellomfaktura på et valgfritt beløp, i kroner eller som prosent av kontrakten. Den legges inn i planen som et fakturert ledd, og sluttfakturaen blir det som gjenstår. Beløpet kan ikke være mer enn det som gjenstår.",
        },
        {
          title: "Terminfakturaer heter «Mellomfaktura»",
          kind: "rettet",
          body: "Fakturaer for ledd mellom oppstart og slutt ble vist som «Mersalg» i fakturalisten. Nå heter de «Mellomfaktura», og du kan filtrere på dem i Fakturaer.",
        },
      ],
    },
  ],
};
